import {ajax, addClass, addClassAll, event, removeClassAll, selectDoc, selectArr, removeClass} from "../utils/utils";
import { ProductCard } from '.';
// import {QuickView} from "./component.quickview";

import {initSlider} from "../helpers/service.slider";
import {PCP} from "./component.pcp";


const props = {
    cards: selectArr('.product-card'),
    body: selectDoc('body'),
    viewer: selectDoc('#global-3d-viewer'),
    iframe: selectDoc('#global-3d-viewer #g3dvIframe'),
    title: selectDoc('#global-3d-viewer .viewer-footer .title'),
    price: selectDoc('#global-3d-viewer .viewer-footer .price'),
    shop: selectDoc('#global-3d-viewer .viewer-footer .btn'),


    opener3d: selectDoc('#global3d-modal-opener'),
    viewer3d: selectDoc('#global3d-modal'),
    iframe3d: selectDoc('#global3d-modal #g3dvIframe'),
    title3d: selectDoc('#global3d-modal .viewer-footer .title'),
    price3d: selectDoc('#global3d-modal .viewer-footer .price'),
    shop3d: selectDoc('#global3d-modal .viewer-footer .btn'),

    zoomFixed: false,
    colors: selectArr('#global3d-modal .iframeFooter button'),
    iframeAwsUrl: "https://d2zjrbs3h0xk1e.cloudfront.net"
};


const updateIFrame = (message = null) => {
    if (message) {
        if (props.iframe3d) {
            if (props.iframe3d.contentWindow) {
                let color = message.replace('-gold', '');
                color = `14k${color.charAt(0).toUpperCase()}${color.substr(1)}_Gold`;
                props.iframe3d.contentWindow.postMessage(color, props.iframeAwsUrl)
            }
        }
    }

    /**
     * Fix zoom issue
     */
    if (!props.zoomFixed) {
        if (props.iframe3d) {
            props.iframe3d.onload = function () {
                if (/(iPad|iPhone)/g.test(navigator.userAgent)) {
                    props.iframe3d.setAttribute('scrolling', 'no');
                }
            }
        }
        props.zoomFixed = true;
    }
}


export const initFCollectionProductCard = (cards = null, slider = true) => {
  addClassAll(selectArr('.fcol-slider'), 'show')
  cards = cards ?? selectArr(`.section-featured-collection .product-card`);
  cards.map(card => {
      let parentClass = ''
      if(slider) {
          parentClass = '.glide__slide:not(.glide__slide--clone) '
          if(card.parentNode.className.includes('glide__slide--clone')) {
              parentClass = '.glide__slide--clone '
          }
      }

      let buttons = selectArr((`${parentClass}#${card.id} .color-variants button:not(.disabled)`));
      buttons.map(btn => {
          event(btn, 'click', function () {
              PCP.switchCardColor(card.id , btn.getAttribute('data-color'))
              $(btn).attr('aria-pressed', 'true');
              $(btn).parent('.color-variants__item').siblings('.color-variants__item').children('button').attr('aria-pressed', 'false');
              $(btn).parent('.color-variants__item').siblings('.color-variants__item').children('label').removeClass('d-block').addClass('d-none');
              $(btn).next().removeClass('d-none').addClass('d-block');

          });
          PCP.switchCardColor(card.id , 'default', false, false)
          if ($(btn).hasClass("active")) {
              $(btn).attr('aria-pressed', 'true');
              $(btn).next().removeClass('d-none').addClass('d-block');
          }
      })


      // 3d viewer

      let cta3d = selectDoc('.view3d',card)
      if(cta3d) {
          event(cta3d, 'click', function (e) {
              e.preventDefault()
              cta3d.classList.add('loading');
              props.iframe3d.src = '';
              props.shop3d.href = cta3d.getAttribute('data-url');
              props.title3d.innerHTML = cta3d.getAttribute('data-name')
              props.price3d.innerHTML = cta3d.getAttribute('data-price')
              let renderer = selectDoc('.pdp-page-renderer', props.viewer3d)
              ajax('GET', props.shop3d.href)
                  .then(function (response) {
                      response = JSON.parse(response).response;
                      renderer.innerHTML = response;
                      let productData = selectDoc('#product-custom-data data', props.viewer3d)
                      if(productData) {
                          try {
                              let data = productData.getAttribute('value')
                              data = JSON.parse(data.replace(/=>/g, ':'))
                              if(data.product_aws) {
                                  props.opener3d.click();
                                  props.iframe3d.src = data.product_aws;
                              }
                              cta3d.classList.remove('loading');
                          } catch (e) {
                              console.log(e)
                          }
                      }
                      renderer.innerHTML = '';
                  })
          })
      }
  });
}



const initializer = () => {

  updateIFrame();

  // Press Logo Slider Initialization
  let g = initSlider(`#press-reviews-slider`, {
    type: 'carousel',
    rewind: true,
    focusAt: 'center',
    animationDuration: 500,
    autoplay: 5000,
    hoverpause: true,
    peek: {
        before: 0,
        after: 0
    },
    breakpoints: {
      768: {
        perView: 1.5
      }
    }
  }, true);

  //   Review Slider
  // Image with Text
  selectArr('.ws-hero-slider').map(heroSlider => {
    let sliders = selectArr(`#${heroSlider.id} .glide__slide`);
    if(sliders.length > 1) {
        initSlider(`#${heroSlider.id}`, {
            rewind: true,
            type: 'carousel',
            focusAt: 'center',
            perView: 1,
            bound: true,
            autoplay: 7560,
            hoverpause: true,
            gap: 0,
            peek: {
                before: 0,
                after: 0
            }
        });
    } else {
        let controls = selectDoc(`#${heroSlider.id} .slider-controls`);
        controls.parentNode.removeChild(controls);
    }
  })

  // Image with Text
  selectArr('.reviews-slider').map(slider => {
    initSlider(`#${slider.id}`, {
        perView: 4,
        gap: 0,
        type: 'carousel',
        rewind: true,
        bound: true,
        hoverpause: false,
        animationDuration: 1000,
        peek: {
            before: 0,
            after: 0
        },
        breakpoints: {
            1024: {
                perView:3
            },
            767: {
                animationDuration: 500,
                perView: 2,
                gap: 0,
                peek: {
                    before: 0,
                    after: 70
                }
            }
        }
    }, true);
  });

  // Featured Collection Slider Initialization
  selectArr('.products-slider').map(slider => {
    initSlider(`#${slider.id}`, {
        perView: 4,
        type: 'carousel',
        rewind: true,
        bound: true,
        hoverpause: false,
        animationDuration: 1000,
        peek: {
            before: 0,
            after: 0
        },
        breakpoints: {
            1024: {
                perView:3
            },
            767: {
                animationDuration: 500,
                perView: 1.4,
                gap: 16,
                peek: {
                    before: 0,
                    after: 70
                }
            }
        }
    }, true);
  });

    //   Suburban moms page reviews slider
  initSlider('#reviews-slider', {
    perView: 1,
    type: 'slider',
    gap: 0,
    peek: {
        before: 0,
        after: 0
    }
  });

  setTimeout(() => {
    initFCollectionProductCard();
    //   QuickView.init();
  }, 2000);
}


export const Millenials = {
  init: () => initializer()
}
